/**
 * Helpers for resolving LW static-asset URLs at runtime.
 *
 * Content metadata (e.g. infosheet JSONs in @lyrahealth-inc/lt-metadata) may use the
 * `{{ASSETS_HOST}}` token in place of a literal CDN host so the same JSON can be
 * served against either the staging or production CloudFront distribution.
 *
 * Buckets + domains are documented at:
 *   https://lyrahealth.atlassian.net/wiki/spaces/EN/pages/2771092393/LW+static+assets
 */

export const ASSETS_HOST_PRODUCTION = 'https://assets.production.lyrahealth.com'
export const ASSETS_HOST_STAGING = 'https://assets.staging.lyrahealth.com'

export const ASSETS_HOST_TOKEN = '{{ASSETS_HOST}}'

/**
 * Returns the CloudFront host that should serve static assets for the current build.
 *
 * Only `NODE_ENV === 'production'` resolves to the production bucket.
 */
const getAssetsHost = (): string => {
  if (typeof __DEV__ !== 'undefined') {
    return __DEV__ ? ASSETS_HOST_STAGING : ASSETS_HOST_PRODUCTION
  }
  const env = typeof process !== 'undefined' ? process.env?.NODE_ENV : undefined
  return env === 'production' ? ASSETS_HOST_PRODUCTION : ASSETS_HOST_STAGING
}

/**
 * Replaces every occurrence of the `{{ASSETS_HOST}}` token in the given string with
 * the host returned by `getAssetsHost()`. Safe to call on values that contain no token.
 */
export const resolveAssetTokens = (value: string): string => {
  if (!value || value.indexOf(ASSETS_HOST_TOKEN) === -1) return value
  return value.split(ASSETS_HOST_TOKEN).join(getAssetsHost())
}
